import React from "react";

import styles from "./AccountDetails.module.scss";

export const AccountDetailsContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div
    className={`${styles.accountDetailsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
);

export const UserSettingsContainer: React.FC<
  React.FormHTMLAttributes<HTMLFormElement>
> = ({ children, className, ...rest }) => (
  <form
    className={`${styles.userSettingsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </form>
);

export const FirstUserSettingsContainer: React.FC<
  React.FormHTMLAttributes<HTMLFormElement>
> = ({ children, className, ...rest }) => (
  <form
    className={`${styles.userSettingsContainer} ${styles.firstUserSettingsContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </form>
);

export const FlexRow: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.flexRow} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const UserName: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.userName} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const FieldsSection: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.fieldsSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const ButtonWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.buttonWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const AccountTitleWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.accountTitleWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
